// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"r8 uX","ribbon":"r9 u6","title":"r- uZ","year":"r_ u0","genres":"sa u5","duration":"sb","buttonWrapper":"sc u1","button":"sd u2","price":"se","upperParts":"sf"};